const OurProcessSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Our Simple <strong>3-Step Process</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Selling your El Paso home has never been easier. Here's how we make it happen.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-20 h-20 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
              1
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Contact Us</h3>
            <p className="text-gray-700 leading-relaxed">
              Reach out via phone, email, or our website form. Tell us about your property and your situation. We'll schedule a convenient time to view your home or discuss it over the phone.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-20 h-20 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
              2
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Get Your Offer</h3>
            <p className="text-gray-700 leading-relaxed">
              After evaluating your property, we'll present you with a fair, no-obligation cash offer within 24 hours. No pressure, no gimmicks—just a straightforward offer you can accept or decline.
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-20 h-20 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-6 text-3xl font-bold">
              3
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Close & Get Paid</h3>
            <p className="text-gray-700 leading-relaxed">
              Choose your closing date—as soon as 7 days or whenever works for you. We handle all the paperwork, and you walk away with cash in hand. It's that simple.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2">
            <div className="p-8 md:p-12">
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                What Makes Our Process Different?
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-teal-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>No Repairs Required:</strong> We buy your home exactly as-is. Don't spend a dime on fixes or updates.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-teal-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>No Commissions or Fees:</strong> Unlike traditional sales, you won't pay agent commissions or closing costs.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-teal-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>No Showings or Open Houses:</strong> No strangers walking through your home. One quick visit from us is all it takes.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-teal-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Flexible Timeline:</strong> Need to close quickly? We can do it. Need more time? That works too.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-teal-600 mr-3 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong>Guaranteed Closing:</strong> No financing contingencies means no last-minute surprises. When we make an offer, we close.</span>
                </li>
              </ul>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/4aadcc5f0901a94025c7b24f8fddcad1.jpg"
                alt="Home closing process"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProcessSection;
